<template>
    <div :class="['text-container', currentStyle]" :style="cssVars">
        <template v-if="value.data && value.data.length > 0">
            <p v-for="(item, index) in value.data" :key="index">
                {{ item.text }}
            </p>
        </template>
        <template v-else>
            <NullView tip="[文本]" :height="60" />
        </template>
    </div>
</template>

<script>
import NullView from "./NullView";

export default {
    name: 'TextView',
    components: {
        NullView
    },
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        cssVars() {
            return {
                '--font-family': this.value.font.fontFamily,
                '--font-size': this.value.font.fontSize,
                '--font-weight': this.value.font.fontWeight,
                '--color': this.value.font.color,
                '--line-height': this.value.font.lineHeight,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.text-container {
    width: 100%;
    overflow-y: hidden;

    p {
        height: auto;
        width: 100%;
        word-wrap: break-word;
        word-break: normal;
        white-space: normal;
        text-align: justify;
        text-align-last: left;
        font-family: var(--font-family);
        font-size: var(--font-size);
        font-weight: var(--font-weight);
        color: var(--color);
        line-height: var(--line-height);
    }

    &.style1 {

        // 样式1：文字居中显示
        p {
            text-align-last: center;
        }
    }

    &.style2 {

        // 样式1：文字开头顶格显示
        p {
            text-indent: 0;
        }
    }

    &.style3 {

        // 样式2：文字开头空两个字符显示（段落格式）
        p {
            text-indent: 2em;
        }
    }
}
</style>